export interface CollectionDetail {
  id: string;
  intro: string;
  sections: { title: string; body: string }[];
  chapters: string[];
  notes: string[];
}

export const collectionDetails: Record<string, CollectionDetail> = {
  c1: {
    id: "c1",
    intro:
      "小川望春导演的访谈与作品资料长期散落在各类特典与杂志中，本合集按时间线汇总整理，方便导演爱好者逐部收藏与核对补全。",
    sections: [
      {
        title: "系列概览",
        body: "本合集以作品上映时间为主线，串联小川望春导演的 TV 系列、剧场版与动画短片，并标注每部的制作阵容与获奖情况，帮助按系列批量收藏完整资料。",
      },
      {
        title: "访谈与分镜归档",
        body: "整理多年来的制作访谈、分镜手稿与幕后花絮索引，每部作品附独立条目，方便需要研究导演风格或做资料整理的用户按作品查找。",
      },
      {
        title: "补全与更新",
        body: "整理贴会持续补全新公开的资料，并更新对应目录。若发现某个条目缺失或链接失效，可在评论区反馈，我们会尽快核对并补全。",
      },
    ],
    chapters: [
      "初出茅庐 · 早期短片",
      "TV 系列黄金期",
      "剧场版三部曲",
      "近年企划与特典",
      "附：幕后人员访谈",
    ],
    notes: [
      "所有资料仅供个人收藏与研究使用，请勿用于商业用途。",
      "目录会随新资料公开持续更新，请留意归档页的最新记录。",
      "转载整理请注明来源与整理者。",
    ],
  },
  c3: {
    id: "c3",
    intro:
      "星海林野系列覆盖主机与 PC 多平台，历代版本与资料片繁多，本合集整理平台对照与版本差异，收藏玩家可一站式补齐系列。",
    sections: [
      {
        title: "系列概览",
        body: "星海林野自首作问世以来已推出多个正式续作与资料片，本合集按发售顺序整理各版本，标注平台、首发年份与关键内容差异，方便按系列批量收藏。",
      },
      {
        title: "平台与版本对照",
        body: "针对主机与 PC 的不同版本，分别整理对应平台与 DLC 内容，收藏时可按平台筛选，避免重复或遗漏版本。",
      },
      {
        title: "补全与更新",
        body: "随新作与复刻版公开，整理贴会持续补全并更新目录。若发现版本信息有误，欢迎在评论区指正，我们会及时核对修正。",
      },
    ],
    chapters: [
      "星海林野 · 起源",
      "星海林野 II · 荒原协奏",
      "资料片 · 群星回响",
      "重制版与 DLC 对照",
      "附：原声与设定集",
    ],
    notes: [
      "版本对照表以官方公布信息为准。",
      "资源仅供个人收藏与研究使用。",
      "新资料持续补全中，请留意归档页更新记录。",
    ],
  },
};